module.exports = __webpack_public_path__ + "components/flag/static/square/uz-9d6bf61e65d8a8cd90c91eb1fa1a79cc.svg";